export default __webpack_public_path__ + "static/media/first_class_konfety.1b84d03a.jpg";